export class HaulierScac {
  public scacCode: string;

  static fromDto(data: any): HaulierScac {
    const haulierScac = new HaulierScac();

    if (!data) {
      return null;
    }

    haulierScac.scacCode = data.scac_code;

    return haulierScac;
  }
}
